
import { defineComponent, PropType, ref, toRef, watchEffect } from 'vue';
import { capitalize } from 'lodash-es';
import { ServerValidationError } from '@/libs/registrationState';
import { LABEL_CONTINUE, LABEL_REGISTRATION_RECOVERY_EMAIL } from '@/libs/i18nLabels';
import PanelHeader from './panel-header.vue';
import useRecoveryEmailValidation from '../libs/recoveryEmailValidation';
import { translateFormLabel, LABEL_EMAIL } from '../libs/form';
import focus from '../libs/focus';

export default defineComponent({
  components: {
    PanelHeader,
  },

  emits: ['onBack', 'submitted'],

  props: {
    serviceName: {
      type: String,
      required: true,
    },

    processing: {
      type: Boolean,
      required: false,
    },

    isVisible: {
      type: Boolean,
      required: false,
    },

    validationErrors: {
      type: Object as PropType<ServerValidationError[]>,
    },
  },

  setup(props, { emit }) {
    const {
      email: recoveryEmail,
      emailMessage: recoveryMessage,
      isEmailInvalid: isRecoveryEmailInvalid,
      displayServerValidationError,
      validate: validRecoveryEmail,
    } = useRecoveryEmailValidation();

    const emailField = ref<HTMLElement>();

    // server validation errors
    const validationErrors = toRef(props, 'validationErrors');

    watchEffect(() => {
      if (validationErrors.value) {
        validationErrors.value.forEach((validationError) => {
          displayServerValidationError(validationError, props.serviceName);
        });
        focus(emailField.value);
      }
    });

    watchEffect(() => {
      // wach because the field can be hidden  by show
      if (props.isVisible) {
        focus(emailField.value);
      }
    });

    function onKeyUp() {
      if (props.processing) {
        return;
      }
      validRecoveryEmail('k');
    }

    function register() {
      if (props.processing) {
        return;
      }

      validRecoveryEmail('');
      if (!isRecoveryEmailInvalid.value) {
        emit('submitted', recoveryEmail.value.toLowerCase());
      } else {
        focus(emailField.value);
      }
    }

    return {
      recoveryEmail,
      recoveryMessage,
      isRecoveryEmailInvalid,
      validRecoveryEmail,
      emailField,
      register,
      onKeyUp,
      LABEL_CONTINUE,
      LABEL_REGISTRATION_RECOVERY_EMAIL,
    };
  },

  computed: {
    recoveryMessageLabel() {
      if (!this.recoveryMessage) {
        return '';
      }
      return translateFormLabel(this.recoveryMessage, this.$t);
    },

    emailabel() {
      return capitalize(this.$t(LABEL_EMAIL).toString());
    },
  },
});
